import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

export const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1.2rem;
  }
`;

export const PageTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Subtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
`;

export const FiltersBar = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 0 0 12px 12px;
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    padding: 1rem;
    gap: 0.75rem;
    overflow-x: auto;
  }
`;

export const LocationNotice = styled.div`
  background: #f0f7ff;
  border: 1px solid #b3d9ff;
  color: #1a5490;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 500;
`;

export const ZipCodePrompt = styled.div`
  background: #fff5f0;
  border: 2px solid #c8553d;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  text-align: center;
`;

export const ZipCodeTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const ZipCodeText = styled.p`
  color: #666;
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

export const ZipCodeForm = styled.form`
  display: flex;
  gap: 1rem;
  max-width: 400px;
  margin: 0 auto;
  align-items: stretch;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ZipCodeInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 0.875rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #c8553d;
  }

  &::placeholder {
    color: #999;
  }
`;

export const ZipCodeButton = styled.button`
  flex-shrink: 0;
  padding: 0.875rem 2rem;
  background: #c8553d;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    background: #b04731;
    transform: translateY(-2px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ErrorText = styled.p`
  color: #c8553d;
  font-size: 0.9rem;
  margin-top: 0.5rem;
`;

export const SearchContainer = styled.div`
  margin-bottom: 0;
  background: linear-gradient(135deg, #c8553d 0%, #f2853b 100%);
  padding: 2.5rem 2rem;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 8px 24px rgba(200, 85, 61, 0.3);

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
    border-radius: 12px 12px 0 0;
  }
`;

export const SearchBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
  max-width: 800px;
  margin: 0 auto;

  &:focus-within {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    border-radius: 40px;
  }
`;

export const SearchIcon = styled.div`
  color: #c8553d;
  font-size: 1.5rem;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin-right: 0.75rem;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 1.125rem;
  color: #333;
  background: transparent;
  min-width: 0;

  &::placeholder {
    color: #999;
    font-size: 1.125rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;

    &::placeholder {
      font-size: 0.9rem;
    }
  }
`;

export const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: #999;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  transition: color 0.3s;
  flex-shrink: 0;
  margin-left: 0.5rem;

  &:hover {
    color: #c8553d;
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
    padding: 0.25rem 0.25rem;
    margin-left: 0.25rem;
  }
`;

export const FilterButton = styled.button<{ $active: boolean }>`
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.$active ? "#C8553D" : "#e0e0e0")};
  background: ${(props) => (props.$active ? "#C8553D" : "white")};
  color: ${(props) => (props.$active ? "white" : "#666")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #c8553d;
    background: ${(props) => (props.$active ? "#b04731" : "#fff5f5")};
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    white-space: nowrap;
  }
`;

export const MealsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #e0e0e0;
  border-top-color: #c8553d;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 12px;
`;

export const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

export const EmptyTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const EmptyText = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 100px;
`;

export const LoadMoreSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top-color: #c8553d;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoadMoreText = styled.p`
  color: #666;
  font-size: 1rem;
  font-weight: 600;
`;

// Location Gate Overlay Styles
export const LocationGateOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
`;

export const LocationGateModal = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem 2rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

export const LocationGateIcon = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
`;

export const LocationGateTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const LocationGateText = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;
